import { SignupContainer } from '@/features/auth';

export default function SignupPage() {
  return <SignupContainer />;
}
